import styled from 'styled-components';
import { Card as CommonCard } from '../../../common/Card/Card';
import { Table as DefaultTable } from '../../../common/Table/Table';

export const Card = styled(CommonCard)`
  margin-bottom: 2rem;
  width: 100%;
`;

export const Table = styled(DefaultTable)`
  margin-bottom: 2rem;
  width: 100%;
`;